import React from 'react';

// TODO: move render viewer id to common
import RenderViewerId from '@components/viewer-sessions/table/CustomCell/RenderViewerId';

function ViewerIdCell({ rowData }) {
  const { VIEWER_ID } = rowData;
  return <RenderViewerId data={VIEWER_ID} cellStyle={{ paddingLeft: 6 }} />;
}

export default React.memo(ViewerIdCell);
